import { useEffect, useRef, useState } from 'react'

import { CompanyOnboarding } from '../types/companyOnboarding'
import { OnboardingForm } from '../types/onboardingForm'
import { useFetchCompanyOnboarding } from './useFetchCompanyOnboarding'

export const usePredefinedOnboardingStepValue = (
  selectValue: (onboarding: CompanyOnboarding | undefined) => Partial<OnboardingForm>,
) => {
  const [predefinedValues, setPredefinedValues] = useState<Partial<OnboardingForm>>()
  const hasCapturedRef = useRef(false)
  const { isLoading, onboarding } = useFetchCompanyOnboarding()

  useEffect(() => {
    if (isLoading || hasCapturedRef.current) {
      return
    }

    hasCapturedRef.current = true
    setPredefinedValues(selectValue(onboarding))
  }, [isLoading, onboarding, selectValue])

  return { isLoading, predefinedValues }
}
